export const VendorRole = Object.freeze({
    ONLY_FINISHER: 1,
    ONLY_SUPPLIER: 2,
    BOTH: 0
})


export const VendorDeliveryStatus = Object.freeze({
    ORDER_CONFIRMATION: 1,
    IN_PRODUCTION: 2,
    EXPECTED_DISPATCHED_DATED: 3,
    IN_TRANSIT: 4,
    DELIVERED: 5,

})